import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UserManager } from '../../auth/user-manager';
import { NavigationService, NavStatus } from '../navigation/navigation.service';
import { NavItem } from '../navigation/navigation.models';
import { AuthUserService } from '../../init/auth-user.service';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.less'],
  standalone: false
})
export class MainSidebarComponent implements OnInit, AfterViewInit {

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();

  username: string = '';

  modeloAso: FormGroup = new FormGroup({
    nome: new FormControl('')
  });

  constructor(
    private router: Router,
    private authUserService: AuthUserService,
    private navigationService: NavigationService
  ) {
    if (this.authUserService.isAnonymous) {
      this.username = 'Visitante';
    } else {
      const user = this.authUserService.getCurrentUser();
      this.username = (!user.isAnonymous ? user.username : null)
        ?? UserManager.getUserInfo()?.username
        ?? 'Usuário';
    }
  }

  get navItems(): NavItem[] {
    return this.navigationService.items;
  }

  get navStatus(): NavStatus {
    return this.navigationService.status();
  }

  retryNavigation(): void {
    this.navigationService.retry();
  }

  ngOnInit() {}

  onCollapsedTreeChildClick(treeItem: HTMLElement): void {
    if (!document.body.classList.contains('sidebar-collapse')) {
      return;
    }

    const sidebarMenu = treeItem.closest('.sidebar-menu');
    if (!sidebarMenu) {
      return;
    }

    Array.from(sidebarMenu.children).forEach((item) => {
      if (!(item instanceof HTMLElement) || !item.classList.contains('treeview')) {
        return;
      }

      const treeviewMenu = item.querySelector<HTMLElement>(':scope > .treeview-menu');

      if (item === treeItem) {
        item.classList.add('menu-open');
        treeviewMenu?.style.removeProperty('display');
        return;
      }

      item.classList.remove('menu-open');
      treeviewMenu?.style.removeProperty('display');
    });
  }

  searchCourses(): void {
    const term = ((this.modeloAso.get('nome')?.value as string) ?? '').trim();

    this.router.navigate(['/catalogo/cursos'], {
      queryParams: { search: term || null },
    });
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();
  }
}
